<template>
  <div class="container-fluid">
    <div class="openingQuestions">
      <div class="row padding-4px">
        <div class="col-md-12 col-lg-12">
          <div class="font-size-19px create-lesson-input-text-style col-md-12 col-lg-12">
            Opening Questions
          </div>  
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-lg-12 padding-bottom-15px">
          <div class="create-lesson-input-text-style col-md-2 col-lg-2">
          </div>
          <div class="create-lesson-input-text-style col-md-4 col-lg-4">
            <span class="font-size-14px glyphicon glyphicon-plus-sign margin-left-10px font-size-17px cursor-pointer" @click="openCreateMissionSubElement($event,'MCQ')"></span>
            <span class="font-size-14px cursor-pointer" @click="openCreateMissionSubElement($event,'MCQ')">Mcq</span>
          </div>
          <div class="create-lesson-input-text-style col-md-4 col-lg-4">
            <span class="font-size-14px glyphicon glyphicon-plus-sign margin-left-10px font-size-17px cursor-pointer" @click="openCreateMissionSubElement($event,'RD')"></span>
            <span class="font-size-14px cursor-pointer" @click="openCreateMissionSubElement($event,'RD')">Reflection</span>
          </div>
          <div class="create-lesson-input-text-style col-md-2 col-lg-2">
          </div>
        </div>
        <!-- <hr class="border-1px"> -->
      </div>
      <div class="row padding-bottom-20px">
        <div class="padding-left-15px">
          <div class="col-md-12 col-lg-12 border-bottom-1px">
          </div>
        </div>
      </div>
      <mission-create-mcq-element v-if="showMissionMcqOverlay" :lessonObj="getParentLessonObj" :MissionGameResp="getMissionGameResp" @openOverlay="updateCloseMcqOverlayValue" :isOpeningQuestion="true"></mission-create-mcq-element>
      <mission-create-rd-element v-if="showMissionRDOverlay" :lessonObj="getParentLessonObj" :MissionGameResp="getMissionGameResp" @openOverlay="updateCloseRDOverlayValue" :isOpeningQuestion="true"></mission-create-rd-element>
      <mission-opening-question-list :overallOpeningQuestionList="getoverallOpeningQuestionList" :lessonObj="getParentLessonObj" :missionGameResp="getMissionGameResp" @updateOverallList="updatedOverallList" :isOpeningQuestion="true"></mission-opening-question-list>
    </div>
  </div>
</template>

<script>
import Loader from '@/components/dashboard/Loader'
import AlertBox from '@/components/AlertOverlay'
import MissionOpeningQuestionList from '@/components/mission_game/update/UpdateMissionOpeningQuestionList'
import MissionCreateMCQElement from '@/components/mission_game/update/UpdateMissionCreateMCQElement'
import MissionCreateRDElement from '@/components/mission_game/update/UpdateMissionCreateRDElement'
export default {
  props: ['lessonObj', 'MissionGameResp', 'openingQuestionList', 'closingQuestionList'],
  data: function () {
    return {
      showAlertDialog: false,
      errorMsg: '',
      showSpinner: false,
      overallOpeningQuestionList: [],
      showMissionMcqOverlay: false,
      showMissionRDOverlay: false
    }
  },
  name: 'openingQuestions',
  methods: {
    updatedOverallList (value) {
      // console.log('Updated Opening List >>> ' + JSON.stringify(value))
      this.overallOpeningQuestionList = value
    },
    updateCloseMcqOverlayValue (value) {
      this.showMissionMcqOverlay = !value.closeOverlay
      if (value.currentResponseObj !== null && value.currentResponseObj.currentResponseObj !== 'null' && value.currentResponseObj.currentResponseObj !== '') {
        this.overallOpeningQuestionList.push(value.currentResponseObj)
      }
      var objToPass = {
        lessonObj: this.getParentLessonObj,
        MissionGameResp: this.getMissionGameResp,
        closeOverlay: false,
        overallOpeningQuestionList: this.getoverallOpeningQuestionList
      }
      this.$emit('HideMainMissionOverlay', objToPass)
    },
    updateCloseRDOverlayValue (value) {
      this.showMissionRDOverlay = !value.closeOverlay
      if (value.currentResponseObj !== null && value.currentResponseObj.currentResponseObj !== 'null' && value.currentResponseObj.currentResponseObj !== '') {
        this.overallOpeningQuestionList.push(value.currentResponseObj)
      }
      var objToPass = {
        lessonObj: this.getParentLessonObj,
        MissionGameResp: this.getMissionGameResp,
        closeOverlay: false,
        overallOpeningQuestionList: this.getoverallOpeningQuestionList
      }
      this.$emit('HideMainMissionOverlay', objToPass)
    },
    openCreateMissionSubElement: function (event, selectedOption) {
      switch (selectedOption) {
        case 'MCQ':
          this.showMissionMcqOverlay = true
          var objToPass = {
            lessonObj: this.getParentLessonObj,
            MissionGameResp: this.getMissionGameResp,
            closeOverlay: true,
            overallOpeningQuestionList: this.getoverallOpeningQuestionList
          }
          this.$emit('HideMainMissionOverlay', objToPass)
          break
        case 'RD':
          this.showMissionRDOverlay = true
          objToPass = {
            lessonObj: this.getParentLessonObj,
            missionGameResp: this.getMissionGameResp,
            closeOverlay: true,
            overallOpeningQuestionList: this.getoverallOpeningQuestionList
          }
          this.$emit('HideMainMissionOverlay', objToPass)
          break
      }
    }
  },
  components: {
    'alert-box': AlertBox,
    'loader': Loader,
    'mission-opening-question-list': MissionOpeningQuestionList,
    'mission-create-mcq-element': MissionCreateMCQElement,
    'mission-create-rd-element': MissionCreateRDElement
  },
  computed: {
    getClosingQuestionListValue: {
      get: function () {
        return this.closingQuestionList
      }
    },
    getOpeningQuestionListValue: {
      get: function () {
        return this.openingQuestionList
      }
    },
    getoverallOpeningQuestionList: {
      get: function () {
        return this.overallOpeningQuestionList
      }
    },
    getMissionGameResp: {
      get: function () {
        // console.log('Opening Questions >>> ' + JSON.stringify(this.MissionGameResp))
        return this.MissionGameResp
      }
    },
    getParentLessonObj: {
      get: function () {
        return this.lessonObj
      }
    }
  },
  watch: {
    getoverallOpeningQuestionList: function (newValue, oldValue) {
      this.$emit('overallOpeningQuestionList', newValue)
    },
    getOpeningQuestionListValue: function (newValue, oldValue) {
      this.overallOpeningQuestionList = this.openingQuestionList
    }
  }
}
</script> 
<style scoped>
.animationload {
    height: 100%;
    left: 0;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 10000;
}
.osahanloading {
    animation: 1.5s linear 0s normal none infinite running osahanloading;
    background: #fed37f none repeat scroll 0 0;
    border-radius: 50px;
    height: 50px;
    left: 50%;
    margin-left: -25px;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 50px;
}
.osahanloading::after {
    animation: 1.5s linear 0s normal none infinite running osahanloading_after;
    border-color: #85d6de transparent;
    border-radius: 80px;
    border-style: solid;
    border-width: 10px;
    content: "";
    height: 80px;
    left: -15px;
    position: absolute;
    top: -15px;
    width: 80px;
}
@keyframes osahanloading {
0% {
    transform: rotate(0deg);
}
50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
}
100% {
    transform: rotate(360deg);
}
}
.red{
  background-color: red;
}
.MainDiv
{
  overflow-y: hidden !important;
}
.margin-Top-0Perc{
  margin-top: 0%;
}
.margin-Top-1Perc{
  margin-top: 1%;
}
.margin-Top-2Perc
{
	margin-top: 2%;
}
.margin-Top-3Perc
{
	margin-top: 3%;
}
.margin-Top-8Perc
{
	margin-top: 8%;
}
.margin-bottom-0Perc
{
	margin-bottom: 0%;
}
.margin-bottom-5Perc
{
	margin-bottom: 5%;
}
.margin-bottom-2Perc
{
	margin-bottom: 2%;
}
.margin-top-2Perc
{
	margin-top: 2%;
}
.margin-left-0Perc
{
    margin-left:0%;
}
.margin-left-1Perc
{
    margin-left:2%;
}
.margin-left-2Perc
{
    margin-left:2%;
}
.margin-left-3Perc{
  margin-left:3%;
}
.margin-left-4Perc
{
    margin-left:4%;
}
.margin-left-5Perc{
  margin-left:5%;
}
.margin-left-6Perc{
  margin-left:6%
}
.margin-left-9Perc
{
    margin-left:9%;
}
.padding-Left-0px
{
  padding-left: 0px !important;
}
.padding-Left-30px
{
  padding-left: 3% !important;
}
.text-align-center
{
  text-align: center;
}
.left-border
{
  border-left: 1px solid #aaa;
}

.background-color-red
{
	background-color: red;
}
.cf-border
{
	border:1px solid black;
}
.text-align-left
{
  text-align: left;
}
.font-size-1-3vw
{
  font-size: 1.3vw;
}
.font-size-20px
{
  font-size: 20px;
}
.background-gray{
  background-color: #ddd;

}

.border-rounded{
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}

  .overflow-x-hidden{
    overflow-x: hidden !important;
  }
  .font-size-18px {
  font-size: 18px;
}
.gray-border {
  border: 1px solid #aaa;
}
.white-BG {
  background-color: #ffffff;
}
.width-70Perc {
  width: 70%;
}
.width-90Perc {
  width: 90%;
}
.margin-auto{
margin: auto;
}
.margin-bottom-0px {
  margin-bottom: 0px !important;
}
.overlay {
  height: 100%;
  width: 0;
  position: fixed;
  z-index: 3;
  top: 0;
  left: 0;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.75);
  overflow-x: hidden;
  /*transition: 0.5s;*/
}
.overlay-overall-width-0Perc {
  width: 0%;
}
.overlay-overall-width-100Perc {
  width: 100% !important;
}
.overlay-content {
  position: relative;
  top: 25%;
  width: 100%;
  text-align: center;
  margin-top: 30px;
}
.center-aligned-div {
  margin: 0 auto;
}
.white-porition-overlay-width-80Perc {
  width: 80%;
}
.background-color-white {
  background-color: #ffffff !important;
}
.close-text-font-style {
  color: #aaa;
  font-size: 30px;
}
.margin-right-1Perc {
  margin-right: 1%;
}
.margin-top-2Perc {
  margin-top: 2%;
}
.cursor-pointer {
  cursor: pointer;
}
.close-img-width-height {
  width: 2%;
  height: 2%;
}
.float-right {
  float: right;
}
.vertical-align {
  display: flex;
  align-items: center;
}
.border-rounded {
  border-bottom-right-radius: 12.5%;
  border-top-left-radius: 12.5%;
  border-top-right-radius: 12.5%;
  border-bottom-left-radius: 12.5%;
}
.create-lesson-input-text-style {
  color: #34495e;
  font-size: 17px;
}
.padding-right-0Px {
  padding-right: 0px !important;
}
switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  -webkit-transition: 0.4s;
  transition: 0.4s;
}
.slider.round {
  border-radius: 34px;
}
.slider.round:before {
  border-radius: 50%;
}
.text-align-right {
  text-align: right;
}
.create-lesson-overlay-button-BG {
  background-color: #f39c12 !important;
  border: 1px solid #f39c12 !important;
}
.black-font-color
{
  color: #000 !important;
}
.border-red {
    border:1px solid red;
}
.margin-bottom-2Perc {
    margin-bottom: 2%;
}
.font-size-19px {
    font-size: 19px;
}
.font-size-14px {
    font-size: 14px !important;
}
.padding-right-6px {
    padding-right:6px; 
}
.padding-top-1Perc {
    padding-top:1%;
}
.padding-left-0px {
    padding-left:0px;
}
.margin-left-10px {
    margin-left: 10px;
}
.padding-4px {
  padding:4px;
}
.font-size-17px {
  font-size:17px;
}
.padding-bottom-15px {
  padding-bottom:15px;
}
hr { 
  display: block;
  /* margin-top: 0.5em; */
  /* margin-bottom: 0.5em; */
  margin-left: auto;
  margin-right: auto;
  border-style: inset;
  width:90%;
}
.border-1px {
  border: 0.5px solid #aaa;
}
.padding-bottom-20px {
  padding-bottom:20px;
}
.padding-left-15px {
  padding-left:15px;
}
.border-bottom-1px {
  border-bottom: 0.5px solid #aaa;
}
</style>


// WEBPACK FOOTER //
// src/components/mission_game/update/UpdateOpeningQuestions.vue